import find from 'lodash/find';

export class RhnscnyService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;

        this.rhnscnyLogoResourceUrl = this.apiService.getResourceUrl('cms/menus/RHNSCNY');
        this.rhnscnyLogoEditResourceUrl = this.apiService.getResourceUrl('cms/:content_id/rhnscny-logo');
        this.rhnscnyLogoResource = this.$resource(this.rhnscnyLogoResourceUrl);
        this.rhnscnyLogoEditResource = this.$resource(this.rhnscnyLogoEditResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }


    //*************************************Public Methods********************* */
    getRhnscnyLogo({data}) {
        return this._getContentDetails(find(data.content, ['name', 'RHNSCNY']).values[0]);
    }

    updateWebsiteLogo({id, image}) {
        const promise = this.rhnscnyLogoEditResource.update({content_id: id}, {image}).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    //*************************************Private Methods********************* */

    _getContentDetails(value) {
		return {
			id: value.content_id,
			image: value.image,
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/rhnscny-logo/rhnscny-logo.service.js